import { getVehicleInfoByLorryType } from "@vahak/core/dist/constants/lorryTypes";

import { CompactLoadPostingState } from "./types";
import { isBodyTypeSelected, isCompactSizeSelected } from "./compactVehicleFields";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export function getLorryTypeLabel(lorryTypeId?: number): string {
    if (!lorryTypeId) {
        return "";
    }

    return getVehicleInfoByLorryType(lorryTypeId, "load")?.label ?? "";
}

export function getBodyTypeLabel(state: CompactLoadPostingState): string | undefined {
    if (!isBodyTypeSelected(state.lorryBodyType) || !state.lorryType) {
        return undefined;
    }

    return getVehicleInfoByLorryType(state.lorryType, "load")?.bodyOptions.find(
        (option) => option.id === state.lorryBodyType
    )?.name;
}

export interface BuildCompactLoadSpecPartsOptions {
    /** When false, size/body are omitted (hero chip keeps capacity). */
    includeVehicleDetails?: boolean;
    /** When false, capacity is omitted. Defaults to true. */
    includeCapacity?: boolean;
    t: TranslateFn;
}

/** Shared spec line parts for LoadSummaryChip and CompactPostingSummaryCard. */
export function buildCompactLoadSpecParts(
    state: CompactLoadPostingState,
    { includeVehicleDetails = true, includeCapacity = true, t }: BuildCompactLoadSpecPartsOptions
): string[] {
    const lorryLabel = getLorryTypeLabel(state.lorryType);
    const capacityLabel =
        includeCapacity && state.tonnes
            ? `${state.tonnes} ${Number(state.tonnes) > 1 ? t("mktCardV2:tonnes") : t("mktCardV2:tonne")}`
            : undefined;
    const sizeLabel =
        includeVehicleDetails && isCompactSizeSelected(state)
            ? state.sizeText
                ? `${state.lorrySize} ${state.sizeText}`
                : `${state.lorrySize} ${t("mktCardV2:ft")}`
            : undefined;
    const bodyTypeLabel = includeVehicleDetails ? getBodyTypeLabel(state) : undefined;

    return [lorryLabel, capacityLabel, sizeLabel, bodyTypeLabel].filter(Boolean) as string[];
}
